export default {
  checkbox: {
    width: '25px'
  },
  conclusionCell: {
    textAlign: 'center'
  },
  conclusion: {
    width: '20px'
  },
  received: {
    width: '80px'
  },
  context: {
    width: '40px',
    height: '40px !important',
    borderRadius: '5px',
    display: 'inline-block'
  }
}
